const clearErrorsByType = (state, { payload }) => ({
  ...state,
  errors: state.errors.filter(({ type }) => !payload.includes(type))
});

export default clearErrorsByType;
